import React from 'react'
import {Link} from 'react-router-dom'
import { SectionHeader_1,Card_4 } from '../../../component/landingComponent'
const CustomBuilt = () => {
    return (
        <div className="container container-large">
            <div className="section-header">
                <SectionHeader_1
                    title={`Custom Built`}
                    subTitle={`For enterprises who wants to create/own their AI Agents`}
                    text={`Leverage our deep expertise to create your own custom AI Agents, tailor made for your unique needs. You can choose your technology stack and we will bring the best practices and skills to build the Agents for you.`}
                />
            </div>
            <div className="fact-content-box">
                <div className="section-content-wrapper p-0">
                    <div className="section-content">
                        <img src="/assets/img/custom-build.jpg" alt="app image" className='radius-20' />
                    </div>
                </div>
                <div className="facts-wrapper">
                    <Link to="/custom-built#how-do-we-do-it" className="fact-box has_fade_anim py-8">
                        <Card_4
                            title={`How we do it?`}
                            subTitle={`We leverage our frameworks, the best practices...`}
                        />
                    </Link> 
                    <Link to="/custom-built#gold-standard" className="fact-box has_fade_anim py-8">
                        <Card_4
                            title={`Gold Standard`}
                            subTitle={`With our deep expertise in Conversational/Agentic AI...`}
                        />
                    </Link>
                    <Link to="/custom-built#quick-to-Market" className="fact-box has_fade_anim py-8">
                        <Card_4
                            title={`Quick to Market`}
                            subTitle={`If time and reliability are critical for you, then talk to us.`}
                        />                                 
                    </Link>
                    <Link to="/custom-built#co-create" className="fact-box has_fade_anim py-8">
                        <Card_4
                            title={`Co-create`}
                            subTitle={`If you have a solid plan to create any exceptional AI...`}
                        />
                    </Link>   
                </div>
            </div>
        </div>
    )
}

export  {CustomBuilt}